import { render, staticRenderFns } from "./TeamsSlider.vue?vue&type=template&id=da106190&"
import script from "./TeamsSlider.vue?vue&type=script&lang=js&"
export * from "./TeamsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports